<template>
     <span class="dropdown">
        <a class="nav-link" :href="$routing('pannier')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart" style="color: #FFFFFF"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
            <span class="badge badge-pill badge-danger badge-up">{{ count }}</span>
        </a>
    </span>
</template>

<script>
    var $this;
    import { EventBus } from '../../helpers/shared'
    export default {
        name: "index",
        data: () => ({
            baskets: [],
            count: 0
        }),
        mounted() {
            //const element = JSON.parse(localStorage.getItem('carts'));
            let carts = this.$storage.getItem('carts');
            if (typeof carts !== 'undefined'){
                const element = JSON.parse(this.$storage.decryptString(this.$storage.getItem('carts')))
                if (Array.isArray(element)){
                    this.baskets = element;
                    this.count = this.baskets.length;
                }
            }else{
                this.$storage.setItem('carts',this.$storage.encryptString(JSON.stringify([])))
            }
            EventBus.$on('remove', this.removeBasket);
            EventBus.$on('addBasket', this.addBasket);
        },
        methods:{
            removeBasket() {
                this.count --;
            },
            addBasket() {
                this.count ++;
            }
        },
        created(){
            $this = this;
        }
    }
</script>

<style scoped>

</style>
